// extracted by mini-css-extract-plugin
export default {"closeButton":"PopupModal_closeButton__hY8H0","modal":"PopupModal_modal__fTXdW","icon":"PopupModal_icon__iGgu4","error":"PopupModal_error__4BR81","info":"PopupModal_info__YLQXz"};